import ScreenHeader from '../components/ScreenHeader.js';

export default function Administration() {
    return (
        <div className="app-wide__container">
            <ScreenHeader message="Administration" />
            <div className="app-wide__add-new" />
            <div className="app-wide__main" style={{ padding: '24px 16px', textAlign: 'center' }}>
                <p>Administration coming soon.</p>
            </div>
            <div className="app-wide__footer" />
        </div>
    );
}
